import React, { useEffect } from "react";

/**
 * Toast en bas d'écran pour proposer d'annuler une suppression optimiste.
 * - Suppression immédiate côté UI
 * - Toast pendant 5s avec bouton "Annuler"
 * - Si annulé : appel de onUndo → restauration de l'état
 * - Si laissé passer : disparition, action définitive
 *
 * Usage :
 *   <UndoToast toast={undoToast} onDismiss={() => setUndoToast(null)} />
 *   setUndoToast({ message: "Exercice supprimé", onUndo: () => { ... } });
 */
export default function UndoToast({ toast, onDismiss }) {
	useEffect(() => {
		if (!toast) return;
		const timer = setTimeout(() => onDismiss?.(), 5000);
		return () => clearTimeout(timer);
	}, [toast, onDismiss]);

	if (!toast) return null;

	return (
		<div className="undo-toast" role="status" aria-live="polite">
			<span className="undo-toast-message">{toast.message}</span>
			<button
				type="button"
				className="undo-toast-btn"
				onClick={() => {
					toast.onUndo?.();
					onDismiss?.();
				}}
			>
				Annuler
			</button>
		</div>
	);
}
